import { createRouter, createWebHistory } from 'vue-router'
import { getQueryString } from 'cupshe-utils'

import store from '../store/index'
import autoRoutes from './autoRoutes.js'
import Watermark from './../utils/watermark'
import { getMFERoutes } from './../utils/mfe'
import NotFound from '../views/404/index.vue'

// 自定义路由
const customerRouters = [
  {
    path: '/',
    name: 'Index',
    redirect: '/home'
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunkName: "Index" */ '../views/Home/index.vue')
  }
]
/**
 * 数组合并
 */
const unique = (arr1, arr2, arr3) => {
  arr1.map(item => {
    const index = arr2.findIndex(subItem => {
      return subItem.name === item.name && subItem.path === item.path
    })
    if (index > -1) {
      arr2.splice(index, 1)
    }
  })
  return [
    ...arr1,
    ...arr2,
    ...arr3,
    {
      path: '/:catchAll(.*)', // 此处需特别注意置于最底部
      name: 'Empty',
      component: NotFound
    }
  ]
}
const mfeRoutes = getMFERoutes([...customerRouters, ...autoRoutes])
// 合并路由
const routes = unique(customerRouters, autoRoutes, mfeRoutes)
// 创建路由对象
const router = createRouter({
  history: createWebHistory(),
  routes
})

/**
 * 页面权限控制
 * @param {*} to
 * @returns
 */
const pagePermission = ['/', '/Login', '/login', '/newlogin', 'newLogin']

const redirectPermisson = ['/', '/home', '/workBench']
/**
 * 域名包含在appDomain中，可跳转
 * @param {*} to
 * @param {*} next
 */
const pageAuthControl = (to, next) => {
  const isProd = process.env.NODE_ENV === 'production'
  // 新增  钉钉地址
  const appDomain = ['.kapeixi.cn', '.cupshe.com']
  let locationHref = location.href
  if (to.query.target) {
    locationHref = to.query.target
  }
  let urlDomain = locationHref.split('/')
  urlDomain[2] ? (urlDomain = urlDomain[2]) : (urlDomain = '')

  urlDomain.split(':')[0].replace(/\.([A-z]+\.[A-z]+)/g, function(word) {
    urlDomain = word
  })

  if (
    appDomain.includes(urlDomain) ||
    pagePermission.includes(to.path) ||
    !isProd
  ) {
    const menus = store.state.user.menus

    const items = menus.filter(item => {
      return item.systemName === '统一网站'
    })

    if (items.length > 0 && redirectPermisson.includes(to.path)) {
      const index = items.findIndex(item => {
        return item.menuPath === to.path
      })
      const menu = index > -1 ? items[index] : items[0]
      if (menu.menuPath === to.path) {
        next()
      } else {
        next(menu.menuPath)
      }
    } else {
      if (redirectPermisson.includes(to.path) && to.path !== '/home') {
        next('/home')
      } else {
        next()
      }
    }
  } else if (['.dingtalk.com'].includes(urlDomain)) {
    window.open(to.query.target)
    return
  } else {
    next('/')
  }
}
// 路由钩子
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  // 平台
  const platform = getQueryString('platform')
  if (platform) {
    localStorage.setItem('sign_platform', platform)
  }
  const isFreshMenus = store.state.app.isFreshMenus
  if (token && !isFreshMenus) {
    // 控制是否刷新菜单
    store.commit('app/SET_FRESHMENUS', true, { root: true })
    await store.dispatch('user/GetMenusAction', {}, { root: true })
    pageAuthControl(to, next)
  } else {
    if (!token && to.name !== 'Login' && to.name !== 'FeishuLogin') {
      sessionStorage.setItem('back', to.fullPath)
      window.localStorage.clear()
      next('/login')
    } else {
      pageAuthControl(to, next)
    }
  }
})

/**
 * 添加水印
 */
router.afterEach(() => {
  const userInfo = store.state.user.userInfo
  if (userInfo) {
    const username = userInfo.userName || ''
    const jobNumber = userInfo.jobNumber || ''
    Watermark.set(username, jobNumber)
  }
})

export default router
